import loadLocaleBundle from 'Translations/loadLocaleBundle'

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages.
const localeReady = loadLocaleBundle()

window.addEventListener("load", () => {
  localeReady.then(() => {
    const ReactRailsUJS = require("react_ujs");
    // this approach requires all components inside New3dPrintModels pod.
    const context = require.context('Pods', true, /\/New3dPrintModels\/(?!.*test.*$).*$/)

    ReactRailsUJS.useContext(context);
    ReactRailsUJS.mountComponents("#print-models");
  })
});
